/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ContractDataSign
 */
export interface ContractDataSign {
    /**
     * 
     * @type {string}
     * @memberof ContractDataSign
     */
    method: ContractDataSignMethodEnum;
    /**
     * 
     * @type {Date}
     * @memberof ContractDataSign
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof ContractDataSign
     */
    dayPart?: ContractDataSignDayPartEnum;
}

export function ContractDataSignFromJSON(json: any): ContractDataSign {
    return ContractDataSignFromJSONTyped(json, false);
}

export function ContractDataSignFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractDataSign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': json['method'],
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'dayPart': !exists(json, 'dayPart') ? undefined : json['dayPart'],
    };
}

export function ContractDataSignToJSON(value?: ContractDataSign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': value.method,
        'date': value.date === undefined ? undefined : (value.date.toISOString().substr(0,10)),
        'dayPart': value.dayPart,
    };
}

/**
* @export
* @enum {string}
*/
export enum ContractDataSignMethodEnum {
    Hand = 'hand',
    Digital = 'digital'
}
/**
* @export
* @enum {string}
*/
export enum ContractDataSignDayPartEnum {
    AM = 'AM',
    PM = 'PM'
}


